import {
  Companion_getInstance1zy63bfjbn01p as Companion_getInstance,
  $serializer_getInstance21thv1dv9fwx4 as $serializer_getInstance,
  CareLocation1v3u5wduz023s as CareLocation,
  get_entries3htl3g20ei9sb as get_entries,
  CareProvider2qcawrqluyllr as CareProvider,
  ID1m87d1hextx54 as ID,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { LinkedHashSetSerializer3ncla559t2lx7 as LinkedHashSetSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { BooleanSerializer_getInstance22aja3hu17sxf as BooleanSerializer_getInstance } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  Always_getInstance177eud73uc475 as Always_getInstance,
  And1a3dbpwh0hxmu as And,
} from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Condition.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  arrayOf1akklvh2at202 as arrayOf,
  toString30pk9tzaqopn as toString_0,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_typeq73z1u2l6557 as get_type,
  get_activeyldcfkk8bem8 as get_active,
  get_provider1s9y5fs8n0r3w as get_provider,
  get_name27z06mu1petol as get_name,
  get__id1301miildb0kq as get__id,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import {
  eq353yrgcpovoi1 as eq,
  xDataClassPathInsideSet2a49hafkm1zud as xDataClassPathInsideSet,
} from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import {
  listOfNotNull2woi2boe01ub4 as listOfNotNull,
  listOf1jh22dvmctj1r as listOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { LabeledViewseav57tyecmf as LabeledView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
  ListSemantic_getInstance2e62q1se6gw64 as ListSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import { listOfvhqybd2zx248 as listOf_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { plus310ted5e4i90h as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { Companion_getInstance23x6zslwzj0st as Companion_getInstance_0 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { chipMultiselect24u6i0cuozpmn as chipMultiselect } from '../components/multiselect.mjs';
import {
  filterMenu2fz1h01y9a2vu as filterMenu,
  FilterChiptjf5vayz5x4r as FilterChip,
  filterChip1bkihjb9h4931 as filterChip,
} from '../components/filters.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import { SortBuilder36qqny2jtmmgx as SortBuilder } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SortBuilder.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { ScrollingBehaviorImpl35p8dxbs74spr as ScrollingBehaviorImpl } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ScrollView.commonHtml.js.mjs';
import { beforeSetup1a13mbd699ddp as beforeSetup } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/ElementWriter.ext.mjs';
import { rowOf3phwx1yo72ntt as rowOf } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/lists.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { modify3w2ijgzr8982m as modify } from '../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { minus27abgkurcn6u0 as minus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { await1uwe8zvsjq69o as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function LocationFilters$Companion$$childSerializers$_anonymous__id27to() {
  return Companion_getInstance().serializer_9w0wvi_k$();
}
function LocationFilters$Companion$$childSerializers$_anonymous__id27to_0() {
  return new (LinkedHashSetSerializer())($serializer_getInstance());
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, LocationFilters$Companion$$childSerializers$_anonymous__id27to);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [tmp_1, null, lazy(tmp_2, LocationFilters$Companion$$childSerializers$_anonymous__id27to_0)];
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_1() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.views.locations.LocationFilters', this, 3);
        tmp0_serialDesc.addElement_5pzumi_k$('type', true);
        tmp0_serialDesc.addElement_5pzumi_k$('active', true);
        tmp0_serialDesc.addElement_5pzumi_k$('providers', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_prz69w_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_1().$childSerializers_1;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !(value.type_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 0, tmp2_cached[0].get_value_j01efc_k$(), value.type_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !(value.active_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 1, BooleanSerializer_getInstance(), value.active_1);
        }
        var tmp;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$0 = emptySet();
          tmp = !equals(value.providers_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, tmp2_cached[2].get_value_j01efc_k$(), value.providers_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_prz69w_k$(encoder, value instanceof LocationFilters() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp8_cached = Companion_getInstance_1().$childSerializers_1;
        if (tmp7_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 0, tmp8_cached[0].get_value_j01efc_k$(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, BooleanSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp8_cached[2].get_value_j01efc_k$(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 0, tmp8_cached[0].get_value_j01efc_k$(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, BooleanSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp8_cached[2].get_value_j01efc_k$(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp7_input.endStructure_1xqz0n_k$(tmp0_desc);
        return LocationFilters().new_org_thecommunitygroupinc_cares_views_locations_LocationFilters_wzngkv_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_1().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [get_nullable(tmp0_cached[0].get_value_j01efc_k$()), get_nullable(BooleanSerializer_getInstance()), tmp0_cached[2].get_value_j01efc_k$()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance_0() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var LocationFiltersClass;
function LocationFilters() {
  if (LocationFiltersClass === VOID) {
    class $ {
      constructor(type, active, providers) {
        Companion_getInstance_1();
        type = type === VOID ? null : type;
        active = active === VOID ? null : active;
        var tmp;
        if (providers === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp = emptySet();
        } else {
          tmp = providers;
        }
        providers = tmp;
        this.type_1 = type;
        this.active_1 = active;
        this.providers_1 = providers;
      }
      toCondition_oj74tc_k$() {
        var tmp = Always_getInstance();
        var tmp0_safe_receiver = this.type_1;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(CareLocation()), arrayOf([]), false));
          var tmp$ret$4 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$4);
          tmp_0 = eq(get_type(it), tmp0_safe_receiver);
        }
        var tmp_2 = tmp_0;
        var tmp1_safe_receiver = this.active_1;
        var tmp_3;
        if (tmp1_safe_receiver == null) {
          tmp_3 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_4 = serializerOrContextual(createKType(getKClass(CareLocation()), arrayOf([]), false));
          var tmp$ret$11 = isInterface(tmp_4, KSerializer()) ? tmp_4 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it_0 = new (DataClassPathSelf())(tmp$ret$11);
          tmp_3 = eq(get_active(it_0), tmp1_safe_receiver);
        }
        var tmp_5 = tmp_3;
        // Inline function 'kotlin.takeUnless' call
        var this_0 = this.providers_1;
        var tmp_6;
        if (!this_0.isEmpty_y1axqb_k$()) {
          tmp_6 = this_0;
        } else {
          tmp_6 = null;
        }
        var tmp2_safe_receiver = tmp_6;
        var tmp_7;
        if (tmp2_safe_receiver == null) {
          tmp_7 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_8 = serializerOrContextual(createKType(getKClass(CareLocation()), arrayOf([]), false));
          var tmp$ret$20 = isInterface(tmp_8, KSerializer()) ? tmp_8 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it_1 = new (DataClassPathSelf())(tmp$ret$20);
          tmp_7 = xDataClassPathInsideSet(get_provider(it_1), tmp2_safe_receiver);
        }
        return And().new_com_lightningkite_services_database_Condition_And_6mqlxl_k$(listOfNotNull([tmp, tmp_2, tmp_5, tmp_7]));
      }
      activeCount_htest3_k$() {
        var count = 0;
        if (!(this.type_1 == null)) {
          count = count + 1 | 0;
        }
        if (!(this.active_1 == null)) {
          count = count + 1 | 0;
        }
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.providers_1.isEmpty_y1axqb_k$()) {
          count = count + 1 | 0;
        }
        return count;
      }
      copy_ju5xn4_k$(type, active, providers) {
        return new (LocationFilters())(type, active, providers);
      }
      copy$default_mski5k_k$(type, active, providers, $super) {
        type = type === VOID ? this.type_1 : type;
        active = active === VOID ? this.active_1 : active;
        providers = providers === VOID ? this.providers_1 : providers;
        return $super === VOID ? this.copy_ju5xn4_k$(type, active, providers) : $super.copy_ju5xn4_k$.call(this, type, active, providers);
      }
      toString() {
        return 'LocationFilters(type=' + toString_0(this.type_1) + ', active=' + this.active_1 + ', providers=' + toString(this.providers_1) + ')';
      }
      hashCode() {
        var result = this.type_1 == null ? 0 : this.type_1.hashCode();
        result = imul(result, 31) + (this.active_1 == null ? 0 : getBooleanHashCode(this.active_1)) | 0;
        result = imul(result, 31) + hashCode(this.providers_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LocationFilters()))
          return false;
        if (!equals(this.type_1, other.type_1))
          return false;
        if (!(this.active_1 == other.active_1))
          return false;
        if (!equals(this.providers_1, other.providers_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_views_locations_LocationFilters_wzngkv_k$(seen0, type, active, providers, serializationConstructorMarker) {
        Companion_getInstance_1();
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, $serializer_getInstance_0().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.type_1 = null;
        else
          $this.type_1 = type;
        if (0 === (seen0 & 2))
          $this.active_1 = null;
        else
          $this.active_1 = active;
        if (0 === (seen0 & 4)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp.providers_1 = emptySet();
        } else
          $this.providers_1 = providers;
        return $this;
      }
    }
    initMetadataForClass($, 'LocationFilters', LocationFilters, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
    LocationFiltersClass = $;
  }
  return LocationFiltersClass;
}
function locationFilters(_this__u8e3s4, target) {
  var tmp = locationFilters$slambda(target);
  return filterMenu(_this__u8e3s4, target, tmp, ($this$filterMenu) => {
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$($this$filterMenu.get_context_h02k06_k$());
    ensureOutermostElement(element);
    $this$filterMenu.willAddChild_hz2iwc_k$(element);
    element.set_content_lzqutq_k$('Type');
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    var this_0 = themed(element, FieldSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = new (RowOrCol())(this_0.get_context_h02k06_k$());
    ensureOutermostElement(element_0);
    this_0.willAddChild_hz2iwc_k$(element_0);
    element_0.set_vertical_nuap32_k$(false);
    // Inline function 'com.lightningkite.kiteui.views.expanding' call
    // Inline function 'com.lightningkite.kiteui.views.direct.select' call
    var this_1 = weight(element_0, 1.0);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_1 = new (Select())(this_1.get_context_h02k06_k$());
    ensureOutermostElement(element_1);
    this_1.willAddChild_hz2iwc_k$(element_1);
    var tmp = locationFilters$lambda$lambda;
    var tmp_0 = target.lens_u4wb4z_k$(tmp, locationFilters$lambda$lambda_0);
    var tmp_1 = _Constant___init__impl__v45mub(plus(listOf_0(null), get_entries()));
    element_1.bind_64a41i_k$(tmp_0, new (Constant())(tmp_1), locationFilters$lambda$lambda_1);
    element_1.onStartup_vrxh3i_k$();
    this_1.addChild_2qpft2_k$(element_1);
    element_0.onStartup_vrxh3i_k$();
    this_0.addChild_2qpft2_k$(element_0);
    element.onStartup_vrxh3i_k$();
    $this$filterMenu.addChild_2qpft2_k$(element);
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_2 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$($this$filterMenu.get_context_h02k06_k$());
    ensureOutermostElement(element_2);
    $this$filterMenu.willAddChild_hz2iwc_k$(element_2);
    element_2.set_content_lzqutq_k$('Status');
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    var this_2 = themed(element_2, FieldSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_3 = new (RowOrCol())(this_2.get_context_h02k06_k$());
    ensureOutermostElement(element_3);
    this_2.willAddChild_hz2iwc_k$(element_3);
    element_3.set_vertical_nuap32_k$(false);
    // Inline function 'com.lightningkite.kiteui.views.expanding' call
    // Inline function 'com.lightningkite.kiteui.views.direct.select' call
    var this_3 = weight(element_3, 1.0);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_4 = new (Select())(this_3.get_context_h02k06_k$());
    ensureOutermostElement(element_4);
    this_3.willAddChild_hz2iwc_k$(element_4);
    var tmp_2 = locationFilters$lambda$lambda_2;
    var tmp_3 = target.lens_u4wb4z_k$(tmp_2, locationFilters$lambda$lambda_3);
    var tmp_4 = _Constant___init__impl__v45mub(listOf([null, true, false]));
    element_4.bind_64a41i_k$(tmp_3, new (Constant())(tmp_4), locationFilters$lambda$lambda_4);
    element_4.onStartup_vrxh3i_k$();
    this_3.addChild_2qpft2_k$(element_4);
    element_3.onStartup_vrxh3i_k$();
    this_2.addChild_2qpft2_k$(element_3);
    element_2.onStartup_vrxh3i_k$();
    $this$filterMenu.addChild_2qpft2_k$(element_2);
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    var label = 'Care provider';
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_5 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$($this$filterMenu.get_context_h02k06_k$());
    ensureOutermostElement(element_5);
    $this$filterMenu.willAddChild_hz2iwc_k$(element_5);
    element_5.set_content_lzqutq_k$(label);
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    var tmp_5 = themed(element_5, FieldSemantic_getInstance());
    var tmp_6 = locationFilters$lambda$lambda_5;
    var tmp_7 = target.lens_u4wb4z_k$(tmp_6, locationFilters$lambda$lambda_6);
    var tmp_8 = remember(VOID, VOID, VOID, VOID, locationFilters$lambda$lambda_7);
    chipMultiselect(tmp_5, tmp_7, tmp_8, locationFilters$lambda$lambda_8, 'Showing all', Companion_getInstance_0().filterList_1);
    element_5.onStartup_vrxh3i_k$();
    $this$filterMenu.addChild_2qpft2_k$(element_5);
    return Unit_instance;
  });
}
function locationFilterChips(_this__u8e3s4, filter) {
  var providerDisplays = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
    var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careProviders_b5tc2w_k$();
    // Inline function 'com.lightningkite.services.database.sort' call
    // Inline function 'kotlin.apply' call
    var this_0 = new (SortBuilder())();
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(CareProvider()), arrayOf([]), false));
    var tmp$ret$4 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    var it = new (DataClassPathSelf())(tmp$ret$4);
    this_0.ascending_ijynum_k$(get_name(it));
    // Inline function 'com.lightningkite.services.database.Query' call
    var orderBy = this_0.build_1k0s4u_k$();
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_1 = serializerOrContextual(createKType(getKClass(CareProvider()), arrayOf([]), false));
    var tmp$ret$8 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
    var it_0 = new (DataClassPathSelf())(tmp$ret$8);
    var tmp$ret$9 = xDataClassPathInsideSet(get__id(it_0), $this$remember.invoke_r7m7el_k$(filter).providers_1);
    var tmp$ret$6 = new (Query())(tmp$ret$9, orderBy, 0, 100);
    return $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(tmp$ret$6));
  });
  var chips = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    var tmp0_safe_receiver = $this$remember.invoke_r7m7el_k$(filter).type_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this_0.add_utx5q5_k$(new (FilterChip())(tmp0_safe_receiver, tmp0_safe_receiver.displayName_1, locationFilterChips$lambda$slambda(filter)));
    }
    var tmp1_safe_receiver = $this$remember.invoke_r7m7el_k$(filter).active_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp = tmp1_safe_receiver ? 'Active' : 'Inactive';
      this_0.add_utx5q5_k$(new (FilterChip())(tmp1_safe_receiver, tmp, locationFilterChips$lambda$slambda_0(filter)));
    }
    // Inline function 'kotlin.collections.mapTo' call
    var _iterator__ex2g4s = $this$remember.invoke_r7m7el_k$(providerDisplays).iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s.next_20eer_k$();
      var tmp$ret$19 = new (FilterChip())(new (ID())(item._id_1), item.name_1, locationFilterChips$lambda$slambda_1(filter, item));
      this_0.add_utx5q5_k$(tmp$ret$19);
    }
    return this_0.build_nmwvly_k$();
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.scrollingHorizontally' call
  // Inline function 'com.lightningkite.kiteui.views.direct.__scrollsUncontracted' call
  var this_0 = themed(shownWhen(_this__u8e3s4, VOID, VOID, ($this$shownWhen) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !$this$shownWhen.invoke_r7m7el_k$(chips).isEmpty_y1axqb_k$();
  }), ListSemantic_getInstance());
  var vertical = false;
  var horizontal = true;
  var tmp = beforeSetup(this_0, ($this$beforeSetup) => {
    (new (ScrollingBehaviorImpl())($this$beforeSetup, horizontal, vertical)).set_showScrollBars_vutwwi_k$(false);
    return Unit_instance;
  });
  var tmp_0 = locationFilterChips$lambda;
  var tmp_1 = locationFilterChips$lambda_0;
  rowOf(tmp, chips, tmp_0, VOID, tmp_1, locationFilterChips$lambda_1);
}
function locationFilters$slambda($target) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    yield* $target.set_revjhg_k$(new (LocationFilters())(), $completion);
    return Unit_instance;
  }), 0);
}
function locationFilters$lambda$lambda(it) {
  return it.type_1;
}
function locationFilters$lambda$lambda_0(old, new_0) {
  return old.copy$default_mski5k_k$(new_0);
}
function locationFilters$lambda$lambda_1(it) {
  var tmp1_elvis_lhs = it == null ? null : it.displayName_1;
  return tmp1_elvis_lhs == null ? 'All' : tmp1_elvis_lhs;
}
function locationFilters$lambda$lambda_2(it) {
  return it.active_1;
}
function locationFilters$lambda$lambda_3(old, new_0) {
  return old.copy$default_mski5k_k$(VOID, new_0);
}
function locationFilters$lambda$lambda_4(it) {
  if (it == null)
    return 'All';
  return it ? 'Active' : 'Inactive';
}
function locationFilters$lambda$lambda_5(it) {
  return it.providers_1;
}
function locationFilters$lambda$lambda_6(old, it) {
  return old.copy$default_mski5k_k$(VOID, VOID, it);
}
function locationFilters$lambda$lambda_7($this$remember) {
  return $this$remember.invoke_r7m7el_k$($this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careProviders_b5tc2w_k$().query_so6xq1_k$(new (Query())(Always_getInstance(), VOID, VOID, 2147483647)));
}
function locationFilters$lambda$lambda_8(it) {
  return it.name_1;
}
function locationFilterChips$lambda$slambda$slambda() {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    return it.copy$default_mski5k_k$(null);
  }), 1);
}
function locationFilterChips$lambda$slambda($filter) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    yield* modify($filter, locationFilterChips$lambda$slambda$slambda(), $completion);
    return Unit_instance;
  }), 1);
}
function locationFilterChips$lambda$slambda$slambda_0() {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    return it.copy$default_mski5k_k$(VOID, null);
  }), 1);
}
function locationFilterChips$lambda$slambda_0($filter) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    yield* modify($filter, locationFilterChips$lambda$slambda$slambda_0(), $completion);
    return Unit_instance;
  }), 1);
}
function locationFilterChips$lambda$slambda$slambda_1($provider) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    return it.copy$default_mski5k_k$(VOID, VOID, minus(it.providers_1, new (ID())($provider._id_1)));
  }), 1);
}
function locationFilterChips$lambda$slambda_1($filter, $provider) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    yield* modify($filter, locationFilterChips$lambda$slambda$slambda_1($provider), $completion);
    return Unit_instance;
  }), 1);
}
function locationFilterChips$lambda(it) {
  return to(it.value_1, it.label_1);
}
function locationFilterChips$lambda_0($this$rowOf) {
  return get_centered($this$rowOf);
}
function locationFilterChips$lambda_1($this$rowOf, item) {
  var tmp = lens(item, locationFilterChips$lambda$lambda);
  filterChip($this$rowOf, tmp, VOID, locationFilterChips$lambda$slambda_2(item));
  return Unit_instance;
}
function locationFilterChips$lambda$lambda(it) {
  return it.label_1;
}
function locationFilterChips$lambda$slambda_2($item) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $item;
    yield* (yield* await_0(this_0, $completion)).remove_94srgz_k$($completion);
    return Unit_instance;
  }), 0);
}
//region block: exports
export {
  LocationFilters as LocationFilters8pzx7as7uqbu,
  locationFilterChips as locationFilterChips2ao2wx91nexbk,
  locationFilters as locationFilters82x3gyv9gdze,
};
//endregion

//# sourceMappingURL=LocationFilters.mjs.map
